"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.function.name.js");

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["innerRef"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var isBrowser = typeof window !== "undefined";

function responsiveHOC() {
  var _this = this;

  var wait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 150;
  var debounceOptions = arguments.length > 1 ? arguments[1] : undefined;
  return function (Component) {
    (0, _newArrowCheck2["default"])(this, _this);

    var Responsive = /*#__PURE__*/function (_React$Component) {
      (0, _inherits2["default"])(Responsive, _React$Component);

      var _super = _createSuper(Responsive);

      function Responsive(props) {
        var _this2;

        (0, _classCallCheck2["default"])(this, Responsive);
        _this2 = _super.call(this, props);
        _this2.state = {
          containerWidth: isBrowser ? window.innerWidth : 0
        };
        _this2.onResize = (0, _debounce2["default"])(_this2.onResize.bind((0, _assertThisInitialized2["default"])(_this2)), wait, debounceOptions);
        return _this2;
      }

      (0, _createClass2["default"])(Responsive, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          window.addEventListener("resize", this.onResize);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onResize);
          this.onResize.cancel();
        }
      }, {
        key: "onResize",
        value: function onResize() {
          this.setState({
            containerWidth: window.innerWidth
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              innerRef = _this$props.innerRef,
              rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
          return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
            ref: innerRef
          }, rest, this.state));
        }
      }]);
      return Responsive;
    }(_react["default"].Component);

    Responsive.displayName = "Responsive(".concat(Component.displayName || Component.name, ")");
    Responsive.defaultProps = {
      innerRef: function innerRef() {}
    };
    Responsive.propTypes = {
      /**
       * 设置组件的Refs
       */
      innerRef: _propTypes["default"].func
    };
    return Responsive;
  }.bind(this);
}

var _default = responsiveHOC;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/TextEllipsis/responsiveHOC.js
// module id = 2118
// module chunks = 6 7 17 18